import { useT } from '@transifex/react'
import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router'
import { getPathTitlesDynamic } from './pathTitlesDynamic'
import { getPathTitlesStatic } from './pathTitlesStatic'

export const KUDOS = 'Kudos\u00AE'

export const useDocumentTitle = () => {
  const location = useLocation()
  const t = useT()

  /**
   * NOTE: Use useMemo to make pageTitle reactive to language changes
   * by including t() in its dependency array.
   */
  const pageTitle = useMemo(() => {
    const staticTitles = getPathTitlesStatic(t)
    const dynamicTitles = getPathTitlesDynamic(t)
    let title = staticTitles[location.pathname]

    if (!title) {
      const dynamicPath = dynamicTitles.find(path => path.pattern.test(location.pathname))
      title = dynamicPath ? dynamicPath.title : KUDOS
    }

    return title
  }, [location.pathname, t])

  useEffect(() => {
    document.title = `${KUDOS} - ${pageTitle}`
  }, [pageTitle])
}
